<template>
  <div>
    <router-view/>
  </div>
  <notifications position="top right" classes="vue-notification mt-3" />
</template>

<script>
    export default {
        name: 'App'
    }
</script>

<style>
    #app {
       /* font-family: 'Avenir', Helvetica, Arial, sans-serif;*/
       font-family: 'Verdana', sans-serif; 
       -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        color: #2c3e50;
    }
</style>